"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrganizationRoleRequestSchema = exports.createOrganizationRoleRequestSchema = exports.updateOrganizationTenantAccessRequestSchema = exports.createOrganizationTenantAccessRequestSchema = exports.organizationAccessOverviewResponseSchema = exports.organizationMemberAccessSchema = exports.updateOrganizationTenantStatusRequestSchema = exports.createOrganizationTenantRequestSchema = exports.organizationTenantSummarySchema = exports.organizationTenantAccessGrantSchema = exports.organizationRoleTemplateSchema = exports.organizationLocationAccessSelectionSchema = exports.organizationLocationAccessModeSchema = exports.organizationTenantStatusSchema = exports.organizationAccessLevelSchema = void 0;
const zod_1 = require("zod");
const business_1 = require("./business");
const staff_capability_1 = require("./staff-capability");
const team_1 = require("./team");
exports.organizationAccessLevelSchema = zod_1.z.enum([
    "OWNER",
    "ADMIN",
    "MEMBER",
]);
exports.organizationTenantStatusSchema = zod_1.z.enum(["ACTIVE", "ARCHIVED"]);
exports.organizationLocationAccessModeSchema = zod_1.z.enum(["ALL", "SELECTED"]);
exports.organizationLocationAccessSelectionSchema = zod_1.z
    .object({
    mode: exports.organizationLocationAccessModeSchema,
    locationIds: zod_1.z
        .array(business_1.operationalLocationIdSchema)
        .max(250)
        .refine((items) => new Set(items).size === items.length, {
        message: "Location IDs must be unique.",
    }),
})
    .superRefine((value, context) => {
    if (value.mode === "ALL" && value.locationIds.length > 0) {
        context.addIssue({
            code: "custom",
            path: ["locationIds"],
            message: "ALL location access cannot include selected location IDs.",
        });
    }
    if (value.mode === "SELECTED" && value.locationIds.length === 0) {
        context.addIssue({
            code: "custom",
            path: ["locationIds"],
            message: "Select at least one operational location.",
        });
    }
});
exports.organizationRoleTemplateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    key: zod_1.z.string().min(1).max(64),
    name: zod_1.z.string().min(1).max(80),
    description: zod_1.z.string().max(500).nullable(),
    legacyMembershipRole: business_1.membershipRoleSchema,
    isSystem: zod_1.z.boolean(),
    capabilities: zod_1.z.array(staff_capability_1.staffCapabilitySchema),
});
exports.organizationTenantAccessGrantSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string().uuid(),
    tenantName: zod_1.z.string().min(1).max(120),
    businessId: zod_1.z.string().uuid(),
    businessName: zod_1.z.string().min(1).max(120),
    membershipId: zod_1.z.string().uuid(),
    roleId: zod_1.z.string().uuid(),
    role: business_1.membershipRoleSchema,
    status: team_1.membershipStatusSchema,
    isDefault: zod_1.z.boolean(),
    capabilities: zod_1.z.array(staff_capability_1.staffCapabilitySchema),
    locationAccess: exports.organizationLocationAccessSelectionSchema,
});
exports.organizationTenantSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    displayName: zod_1.z.string().min(1).max(120),
    businessId: zod_1.z.string().uuid(),
    businessName: zod_1.z.string().min(1).max(120),
    status: exports.organizationTenantStatusSchema,
    multiLocationEnabled: zod_1.z.boolean().optional(),
    isPrimary: zod_1.z.boolean(),
    locations: zod_1.z.array(business_1.operationalLocationAccessSchema).min(1),
});
exports.createOrganizationTenantRequestSchema = business_1.onboardBusinessRequestSchema.extend({
    tenant: zod_1.z.object({
        displayName: zod_1.z.string().trim().min(2).max(120),
    }),
});
exports.updateOrganizationTenantStatusRequestSchema = zod_1.z.object({
    status: exports.organizationTenantStatusSchema,
});
exports.organizationMemberAccessSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    userId: zod_1.z.string().uuid(),
    displayName: zod_1.z.string().nullable(),
    email: zod_1.z.string().email().nullable(),
    accessLevel: exports.organizationAccessLevelSchema,
    status: team_1.membershipStatusSchema,
    grants: zod_1.z.array(exports.organizationTenantAccessGrantSchema),
});
exports.organizationAccessOverviewResponseSchema = zod_1.z.object({
    organization: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        displayName: zod_1.z.string().min(1).max(120),
    }),
    canManage: zod_1.z.boolean(),
    tenants: zod_1.z.array(exports.organizationTenantSummarySchema),
    roles: zod_1.z.array(exports.organizationRoleTemplateSchema),
    members: zod_1.z.array(exports.organizationMemberAccessSchema),
});
exports.createOrganizationTenantAccessRequestSchema = zod_1.z.object({
    organizationMembershipId: zod_1.z.string().uuid(),
    tenantId: zod_1.z.string().uuid(),
    roleId: zod_1.z.string().uuid(),
    isDefault: zod_1.z.boolean(),
    capabilities: zod_1.z.array(staff_capability_1.staffCapabilitySchema).superRefine((items, context) => {
        if (new Set(items).size !== items.length) {
            context.addIssue({
                code: "custom",
                message: "Capabilities must be unique.",
            });
        }
    }),
    locationAccess: exports.organizationLocationAccessSelectionSchema.default({
        mode: "ALL",
        locationIds: [],
    }),
});
exports.updateOrganizationTenantAccessRequestSchema = zod_1.z.object({
    roleId: zod_1.z.string().uuid(),
    status: zod_1.z.enum(["ACTIVE", "INACTIVE"]),
    isDefault: zod_1.z.boolean(),
    capabilities: zod_1.z.array(staff_capability_1.staffCapabilitySchema).superRefine((items, context) => {
        if (new Set(items).size !== items.length) {
            context.addIssue({
                code: "custom",
                message: "Capabilities must be unique.",
            });
        }
    }),
    locationAccess: exports.organizationLocationAccessSelectionSchema.default({
        mode: "ALL",
        locationIds: [],
    }),
});
exports.createOrganizationRoleRequestSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(2).max(80),
    description: zod_1.z.string().trim().max(500).nullable(),
    baseRole: zod_1.z.enum(["ADMIN", "DISPATCHER", "TECHNICIAN"]),
    capabilities: zod_1.z.array(staff_capability_1.staffCapabilitySchema).superRefine((items, context) => {
        if (new Set(items).size !== items.length) {
            context.addIssue({
                code: "custom",
                message: "Capabilities must be unique.",
            });
        }
    }),
});
exports.updateOrganizationRoleRequestSchema = exports.createOrganizationRoleRequestSchema.pick({
    name: true,
    description: true,
    capabilities: true,
});
//# sourceMappingURL=organization-access.js.map